import DataTable from "primevue/datatable";
import Column from "primevue/column";
import travellaHeader from "../TravellaHeader";
import SettingsService from "../../shared/settings/settings.service.js";

export default {
    name: "lec-za-darmo",
    components: {
        DataTable,
        Column,
        travellaHeader
    },
    props: [],
    data: function() {
        return {
            kierunki: [],
            czyWidocznyRegulamin: false
        };
    },
    computed: {},
    methods: {
        wczytajDane() {
            this.$http
                .get(`${SettingsService.lecZaDarmoApi}`)
                .then((response) => {
                    this.kierunki = response.body;
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.error(error);
                });
        },
        pokazRegulamin() {
            this.czyWidocznyRegulamin = !this.czyWidocznyRegulamin;
        }
    },
    mounted() {
        this.wczytajDane();
        this.$nextTick(() => {
            travellaHeader.loadHeader();
        });
    }
};
